import { render } from "./Univ-Details.vue?vue&type=template&id=3aa78941&scoped=true"
import script from "./Univ-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Details.vue?vue&type=script&lang=js"

import "./Univ-Details.vue?vue&type=style&index=0&id=3aa78941&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3aa78941"

export default script